import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import { getCompanyById, getCompanyDetailQueryKey } from '../api/companies.client.js';

export function useCompanyDetail(companyId: string) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getCompanyDetailQueryKey(workspaceId, companyId),
    queryFn: () => getCompanyById(companyId),
    enabled: scope !== null,
  });
}
